import React, {useEffect, useState} from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import {confirmAlert} from "react-confirm-alert";


// components
import ActivityFilters from "./_filters";
import ActivityForm from "./_form";
import AvtivityGallery from "./_gallery";
import ActivityAccessPoints from "./_access";
import TranslateButton from "../../../components/buttons/TranslateButton";
import { ConfirmDelete } from "../../../components/confirmAlert/ConfirmDelete";
import { ActiveFormatter}  from "../../../components/tables/activeFormater";
import NotificationForm from "../../comunication/notification/_form";
import NotificationComponent from "./notifications/NotificationComponent";

// labels
import {
    ARE_YOU_SHURE_TITLE, CONFIRM_SYNC, CONFIRM_YES, DELETE_NOTIFICATION, LB_YES_SEND_ALERT,
    LIST, NO,
    NO_DATA_FOUND,
    YOU_SHURE_SEND_ALERT
} from "../../../components/i18n/i18n";
import {
    TT_DELETE,
    TT_EDIT,
    TT_GALLERY,
    TT_SCHEDULE,
} from "../../../components/i18n/toolTips";

// actions

// services
import {activityService} from "../../../jwt/_services/core/activityService";
import {addonActivityPriceService} from "../../../jwt/_services/sales/addonActivityPriceService";
import Prices from "./_prices";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setMapConfig,
    setParent, setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import ActivitySchedule from "../activitySchedule/ActivitySchedule";
import ActivityScheduleFrom from "../activitySchedule/_form";
import ActivityScheduleList from "../activitySchedule/_list";


const ActivityList = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, mapConfig, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    const [isExtraordinary] = useState( props.isExtraordinary || false );

    // asignar los valores por default del filtro
    useEffect( () => {
        if( !app.id || !udn.id || filter)
            return

        props.setFilter( path, {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                udn : { id: udn.id },
                status : null,
                isExtraordinary : isExtraordinary
            }
        } )
    }, [ app, udn ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, activityService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path, tableChangeParams.sizePerPage, currentIndex );
    };

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( ActivityForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path,true, false, false);
        props.setItem(path,data);
        props.setMapConfig(path, {
            ...mapConfig,
            mapOptions : {
                ...mapConfig?.mapOptions,
                center: {
                    lat: parseFloat(data?.latitude),
                    lng: parseFloat(data?.longitude)
                }
            }
        });
        ModalFormContainer(ActivityForm, { path, data, Form: ActivityForm })
    }

    const confirmDelete = data => ConfirmDelete({
        remove: genericIndexedActions.delete ,
        data: data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: activityService,
        path
    } )

    const editSchedules = (data) => {
        props.setItem(path, data);
        // props.setForm(path, true, false, false);
        props.setParent(path, data);
        ModalFormContainer(ActivitySchedule, { data, Form: ActivityScheduleFrom, List: ActivityScheduleList, app })
    }

    const editMedia = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);
        // Se establece el Parent cuando se pretende agregar/editar un elemento o dependencia hija (Child)
        props.setParent(data);
        ModalFormContainer( AvtivityGallery )
    }

    const editAccessPoints = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);
        props.setMapConfig(path, {
            ...mapConfig,
            mapOptions : {
                ...mapConfig?.mapOptions,
                center: {
                    lat: parseFloat(data?.latitude),
                    lng: parseFloat(data?.longitude)
                }
            }
        });
        ModalFormContainer( ActivityAccessPoints )
    }

    const createNotification = data => ModalFormContainer(NotificationForm, {
        data:{...data},
        from:'activity',
        activityID: data?.id
    })

    const sendAlert = data => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{YOU_SHURE_SEND_ALERT}:{data?.notification?.title }</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                props.sendAlert({
                    header:{  app: props.mainProps?.app?.id, },
                    item:{ id: data?.notification?.id }
                })
                onClose();
            }}>
                {LB_YES_SEND_ALERT}
            </button>
            <button className={"btn-alert-remove"} onClick={() => {
                const dataRequest = {
                    fbDataBase: { id: app?.fbDataBase?.id },
                    item:{
                        activityID: data?.id,
                        notificationID: data?.notification?.id
                    }
                }

                props.deleteNotification(dataRequest)
                onClose();
            }}>
                {DELETE_NOTIFICATION}
            </button>
        </div>
    });

    const viewNotifications = data => ModalFormContainer(NotificationComponent, { data })

    const confirmSyncPrice = data => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className={'custom-ui'}>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{CONFIRM_SYNC}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                syncPrice(data)
                onClose();
            }}>
                {CONFIRM_YES}
            </button>
        </div>
    })

    const syncPrice = data => {
        const requestData = {
            item:{
                activityID: data?.id
            }
        }

        props.setLoading(true)

        addonActivityPriceService.syncProductPrices(requestData)
            .then( result => console.log(result?.data))
            .catch( e => console.error(e))
            .finally( () => props.setLoading(false))
    }

    const syncFirebase = () => {
        const requestData = {
            onlyRegistered : true,
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
            }
        }

        props.setLoading(true)

        activityService.sync(requestData)
            .then( result => console.log( result ) )
            .catch( e => console.error(e))
            .finally( () => props.setLoading(false))

    }



    const notImplemented = () => {
        console.log('Not implemented')
    }

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericButton style={'table'} toolTip={TT_GALLERY} icon={'fa-image'} permission={'gallery'} onClick={() => notImplemented(row)}/>
        <TranslateButton item={row} service={activityService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const activeFormatter = cell => <ActiveFormatter active={cell} />

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        },
            {
            dataField: 'uid',
            headerStyle: {width: '200px'},
            text: 'UID'
        }, {
            dataField: 'code',
            text: 'Codigo',
            hidden: true
        }, {
            dataField: 'name',
            text: 'Nombre'
        }, {
            dataField: 'categoryName',
            text: 'Categoria'
        }, {
            dataField: 'number',
            text: 'Número',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
        }, {
            dataField: 'status',
            text: "Activo",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '280px'},
            formatter: actionsFormatter
        }
    ];

    const expandRow = {
        renderer: row => <Prices prices={row?.addonActivity?.prices || []} />,
        showExpandColumn : true,
        expandByColumnOnly: true,
        nonExpandable: listDomainObjects?.map( (item, index) => {
            if(!item?.prices)
                return item?.id
        })
    }

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'danger-secondary'}
                    label={'Sync up'}
                    toolTip={'Sincronizar hacia Firebase'}
                    icon={'fa-sync'}
                    permission={'delete'}
                    onClick={syncFirebase}
                />

                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <ActivityFilters isExtraordinary={isExtraordinary}  path={path}/>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                expandRow={ expandRow }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setParent,
    setMapConfig,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ActivityList)